'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _sidebar = require('../frame/sidebar.jsx');

var _sidebar2 = _interopRequireDefault(_sidebar);

var _topbar = require('../frame/topbar.jsx');

var _topbar2 = _interopRequireDefault(_topbar);

var _form = require('../../basic/form');

var _form2 = _interopRequireDefault(_form);

var _input = require('../../basic/input');

var _input2 = _interopRequireDefault(_input);

var _icon = require('../../basic/icon');

var _icon2 = _interopRequireDefault(_icon);

var _row = require('../../basic/row');

var _row2 = _interopRequireDefault(_row);

var _col = require('../../basic/col');

var _col2 = _interopRequireDefault(_col);

var _button = require('../../basic/button');

var _button2 = _interopRequireDefault(_button);

var _queueAnim = require('../../basic/queue-anim');

var _queueAnim2 = _interopRequireDefault(_queueAnim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormItem = _form2["default"].Item;


var Login = _react2["default"].createClass({
	displayName: 'Login',
	getDefaultProps: function getDefaultProps() {
		return {
			onSubmit: function onSubmit() {},
			title: "欢迎登陆"
		};
	},
	getInitialState: function getInitialState() {
		return {
			formData: {},
			show: false
		};
	},

	componentDidMount: function componentDidMount() {
		this.setState({
			show: true
		});
	},
	setValue: function setValue(func, name, e) {
		var formData = this.state.formData;
		var value = e.target ? e.target.value : e; //Input 传入的是e, select传入的是value
		formData[name] = value;
		this.setState({ formData: formData });
		if (func) func(value);
	},
	onSubmit: function onSubmit(e) {
		e.preventDefault();
		this.props.onSubmit(this.state.formData);
	},
	render: function render() {
		var formEntity = [];
		var keycnt = 0;
		if (this.props.children) {
			if (this.props.children.length) {
				//好像children仅有一个的时候, 就不是list, 而直接是child这个element了
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = this.props.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var child = _step.value;

						var childElement = _react2["default"].cloneElement(child, { onChange: this.setValue.bind(null, child.props["onChange"], child.props["name"]) }); //注意! 这里的label将被渲染为defaultText
						formEntity.push(_react2["default"].createElement(
							FormItem,
							{
								key: "dummy-" + keycnt++,
								label: child.props["labelText"] || "请输入 : ",
								labelCol: { span: 10 },
								wrapperCol: { span: 14 } },
							childElement
						));
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator["return"]) {
							_iterator["return"]();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			} else {
				var child = this.props.children;
				var childElement = _react2["default"].cloneElement(child, { onChange: this.setValue.bind(null, child.props["onChange"], child.props["name"]) }); //注意! 这里的label将被渲染为defaultText

				formEntity.push(_react2["default"].createElement(
					FormItem,
					{
						key: "dummy-addon",
						label: child.props["labelText"] || "请输入 : ",
						labelCol: { span: 8 },
						wrapperCol: { span: 8 } },
					childElement
				));
			}
		}

		return _react2["default"].createElement(
			_form2["default"],
			{ horizontal: true, onSubmit: this.onSubmit, style: {} },
			_react2["default"].createElement(
				_queueAnim2["default"],
				{ delay: 900 },
				this.state.show ? [_react2["default"].createElement(
					'div',
					{ key: 'dummy-title', style: { margin: "20", fontSize: "20", textAlign: "center" } },
					_react2["default"].createElement(
						'p',
						{ className: 'ant-form-text' },
						this.props.title
					)
				), _react2["default"].createElement(
					FormItem,
					{
						key: 'dummy-username',
						label: '用户名：',
						labelCol: { span: 8 },
						wrapperCol: { span: 8 } },
					_react2["default"].createElement(_input2["default"], {
						placeholder: '请输入用户名',
						addonAfter: _react2["default"].createElement(_icon2["default"], { type: 'user' }),
						onChange: this.setValue.bind(this, null, "userLoginName") })
				), _react2["default"].createElement(
					FormItem,
					{
						key: 'dummy-password',
						label: '密码：',
						labelCol: { span: 8 },
						wrapperCol: { span: 8 } },
					_react2["default"].createElement(_input2["default"], { type: 'password',
						placeholder: '请输入密码',
						addonAfter: _react2["default"].createElement(_icon2["default"], { type: 'lock' }),
						onChange: this.setValue.bind(this, null, "userPassword") })
				), formEntity, _react2["default"].createElement(
					_row2["default"],
					{ key: 'dummy-btn' },
					_react2["default"].createElement(
						_col2["default"],
						{ span: '8', offset: '8' },
						_react2["default"].createElement(
							_button2["default"],
							{ type: 'primary', htmlType: 'submit' },
							'登陆'
						)
					)
				)] : null
			)
		);
	}
});

exports["default"] = Login;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/business/page/login.jsx
 ** module id = 625
 ** module chunks = 0
 **/